import React from 'react';

const Logo = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#dc2626" />
          <stop offset="100%" stopColor="#b91c1c" />
        </linearGradient>
      </defs>
      
      {/* Background rounded rectangle */}
      <rect width="200" height="200" rx="24" fill="url(#logoGradient)" />
      
      {/* Roof/House shape */}
      <path d="M100 40 L160 90 L150 90 L150 150 L50 150 L50 90 L40 90 Z" fill="white" opacity="0.9" />
      
      {/* Left window - shorter height */}
      <rect x="60" y="100" width="22" height="22" rx="2" fill="#dc2626" />
      
      {/* Right window - shorter height */}
      <rect x="118" y="100" width="22" height="22" rx="2" fill="#dc2626" />
      
      {/* Door - taller and more centered */}
      <rect x="86" y="120" width="28" height="30" rx="2" fill="#b91c1c" />
      
      {/* Small door knob */}
      <circle cx="108" cy="135" r="2" fill="white" opacity="0.8" />
      
      {/* Roof highlight */}
      <path d="M100 40 L160 90 L40 90 Z" fill="white" opacity="0.2" />
    </svg>
  );
};

export default Logo;